// src/components/LoyaltyProgramSteps/Step1ProgramDetails.js
import React from 'react';
import {IdentificationIcon, DocumentTextIcon, CalendarDaysIcon, GiftIcon} from '@heroicons/react/24/outline';

const Step1ProgramDetails = ({ formData, updateFormData }) => {
    const programTypes = [
        { value: 'points', label: 'Points-based (Earn points, redeem for rewards)' },
        { value: 'tier', label: 'Tier-based (Unlock higher tiers for exclusive benefits)' },
        { value: 'stamp', label: 'Stamp Card (Collect stamps for a free item/discount)' },
        { value: 'spend', label: 'Spend-based (Reach a spend threshold for a reward)' },
    ];

    const today = new Date().toISOString().split('T')[0]; // YYYY-MM-DD format

    return (
        <fieldset className="border p-4 rounded-md space-y-4">
            <legend className="text-lg font-medium text-gray-900 flex items-center">
                <IdentificationIcon className="h-6 w-6 text-indigo-500 mr-2" />
                Step 1: Program Details
            </legend>

            {/* Program Name */}
            <div>
                <label htmlFor="program-name" className="block text-sm font-medium text-gray-700">Program Name</label>
                <div className="relative mt-1">
                    <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
                        <IdentificationIcon className="h-5 w-5 text-gray-400" aria-hidden="true" />
                    </div>
                    <input
                        id="program-name"
                        name="program-name"
                        type="text"
                        required
                        className="block w-full pl-10 pr-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm"
                        placeholder="e.g., LoyalCoffee Rewards, VIP Club"
                        value={formData.programName}
                        onChange={(e) => updateFormData('programName', e.target.value)}
                    />
                </div>
            </div>

            {/* Program Description */}
            <div>
                <label htmlFor="program-description" className="block text-sm font-medium text-gray-700">Program Description</label>
                <div className="relative mt-1">
                    <div className="absolute inset-y-0 left-0 pl-3 pt-2 flex items-start pointer-events-none">
                        <DocumentTextIcon className="h-5 w-5 text-gray-400" aria-hidden="true" />
                    </div>
                    <textarea
                        id="program-description"
                        name="program-description"
                        rows="3"
                        required
                        className="block w-full pl-10 pr-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm"
                        placeholder="Briefly describe your loyalty program. This will be visible to customers."
                        value={formData.programDescription}
                        onChange={(e) => updateFormData('programDescription', e.target.value)}
                    ></textarea>
                </div>
            </div>

            {/* Program Type */}
            <div>
                <label htmlFor="program-type" className="block text-sm font-medium text-gray-700">Program Type</label>
                <div className="relative mt-1">
                    <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
                        <GiftIcon className="h-5 w-5 text-gray-400" aria-hidden="true" />
                    </div>
                    <select
                        id="program-type"
                        name="program-type"
                        required
                        className="block w-full pl-10 pr-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm bg-white"
                        value={formData.programType}
                        onChange={(e) => updateFormData('programType', e.target.value)}
                    >
                        {programTypes.map((type) => (
                            <option key={type.value} value={type.value}>
                                {type.label}
                            </option>
                        ))}
                    </select>
                </div>
            </div>

            <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
                {/* Start Date (Optional) */}
                <div>
                    <label htmlFor="start-date" className="block text-sm font-medium text-gray-700">Start Date (Optional)</label>
                    <div className="relative mt-1">
                        <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
                            <CalendarDaysIcon className="h-5 w-5 text-gray-400" aria-hidden="true" />
                        </div>
                        <input
                            id="start-date"
                            name="start-date"
                            type="date"
                            min={today}
                            className="block w-full pl-10 pr-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm"
                            value={formData.startDate}
                            onChange={(e) => updateFormData('startDate', e.target.value)}
                        />
                    </div>
                </div>

                {/* End Date (Optional) */}
                <div>
                    <label htmlFor="end-date" className="block text-sm font-medium text-gray-700">End Date (Optional)</label>
                    <div className="relative mt-1">
                        <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
                            <CalendarDaysIcon className="h-5 w-5 text-gray-400" aria-hidden="true" />
                        </div>
                        <input
                            id="end-date"
                            name="end-date"
                            type="date"
                            min={formData.startDate || today} // End date cannot be before start date
                            className="block w-full pl-10 pr-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm"
                            value={formData.endDate}
                            onChange={(e) => updateFormData('endDate', e.target.value)}
                        />
                    </div>
                </div>
            </div>
        </fieldset>
    );
};

export default Step1ProgramDetails;